import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import Html from "./html";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

const Content = () => {
  const searchState = { data: "" }
  const user = useSelector((state) => state.user)
  const [filters, setFilter] = useState({ page: 1, count: 10, search: "", status: "" }) 
  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)
  const history = useNavigate()

  useEffect(() => {
    setFilter({ ...filters, search: searchState.data })
    getData({ search: searchState.data })
  }, [])

  const getData = (p = {}) => {
    loader(true)
    let filter = { ...filters, ...p }
    ApiClient.get("content/listing", filter).then((res) => {
      if (res.success) {
        setData(res?.data)
        setTotal(res.total)
      }
      loader(false)
    })
  }

  const clear = () => {
    let f = { search: "", status: "" }; 
    setFilter({ ...filters, ...f });
    getData({ ...f });
  }

  const filter = (p = {}) => {
    let f = { ...p };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  }

 

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  }

  const count = (e) => {
    setFilter({ ...filters, count: e });
    getData({ ...filters, count: e });
  }

  const edit = (id) => {
    history(`/content/edit/${id}`);
  }

  const view = (id) => {
    let url = `/content/detail/${id}`;
    history(url);
  }

  const isAllow = (key = "") => {
    if (user?.role?.name === "admin") return true;
    let permissions = user.Permission;
    let value = permissions?.[key];
    return value;
  }

  const handleSearch = (e) => {
    setFilter({ ...filters, search: e.target.value });
    if (e.target.value === "") {
      getData({ search: "" })
    }
  }
  const changestatus = (e, key) => {
    setFilter({ ...filters, [key]: e });
    getData({ [key]: e });
  }
  const statusChange = (itm) => {
     let status = "active";
        if (itm.status == "active") status = "deactive";
        Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status == "active" ? "Activate" : "Deactivate"} this Content?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true); 
        ApiClient.put("content/status/change", { id: itm?._id || itm?.id, status: status })
          .then((res) => {
            if (res.success) {
              getData({})
            }
            loader(false); // Hide loader
          })
          .catch((error) => {
            loader(false);
            console.error("Error updating status:", error);
          });
      }
    });
  };
  
  return (
    <>
      <Html
        edit={edit}
        view={view}
        clear={clear}
        isAllow={isAllow}
        count={count}
        pageChange={pageChange}
        filters={filters}
        setFilter={setFilter}
        filter={filter}
        data={data}
        total={total}
        statusChange={statusChange}
        changestatus={changestatus}
        handleSearch={handleSearch}
      />
    </>
  );
};

export default Content;
